import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=1aac438d&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerDetail.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=1aac438d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac438d",
  null
  
)

export default component.exports